<div #mainElement><ng-content></ng-content></div>